import { render, staticRenderFns } from "./UsersPrivilegeOffers.vue?vue&type=template&id=515cebac&scoped=true&"
import script from "./UsersPrivilegeOffers.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515cebac",
  null
  
)

export default component.exports